var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal__header--angles" }, [
    _vm.header
      ? _c("div", { staticClass: "modal__header-section" }, [
          _vm.header.title
            ? _c("div", { staticClass: "modal__header-title" }, [
                _vm._v(_vm._s(_vm.header.title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "modal__header-description",
            domProps: { innerHTML: _vm._s(_vm.header.description) }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "modal__close-btn" }, [
      _c("i", { staticClass: "fa fa-times", on: { click: _vm.closeModal } })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "btn-group modal__nav",
        attrs: { role: "group", "aria-label": "..." }
      },
      [
        _c(
          "button",
          {
            staticClass:
              "btn btn-default modal__nav-button modal__nav-button--back",
            attrs: { type: "button", disabled: _vm.isFirst },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.prevItem($event)
              }
            }
          },
          [
            _c("span", {
              staticClass: "glyphicon glyphicon-chevron-left",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn btn-default modal__nav-button modal__nav-button--forward",
            attrs: { type: "button", disabled: _vm.isLast },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.nextItem($event)
              }
            }
          },
          [
            _c("span", {
              staticClass: "glyphicon glyphicon-chevron-right",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }